// extracted by mini-css-extract-plugin
export var buttonRow = "Tabs-module--buttonRow--1c390";
export var alumni = "Tabs-module--alumni--a6960";
export var button = "Tabs-module--button--7c163";
export var line = "Tabs-module--line--4abb3";
export var hidden = "Tabs-module--hidden--62262";